import type { TrustedExtensionIdsResponse } from '@repo/contracts/settings';

import { apiFetch } from '../api/client';
import { sessionKeys } from './session-api';

/**
 * Which extension ids *this* deployment will hand a session token to.
 *
 * Asked of the server rather than read from the bundle, because the answer is
 * per deployment: the compiled `TRUSTED_EXTENSION_IDS` plus, on a test
 * deployment only, whatever an admin added in `platformSettings`. Chrome derives
 * an unpacked extension's id from the path it was loaded from, so no
 * developer's local build has an id worth committing — that gap is what this
 * closes.
 *
 * Under `sessionKeys`, not a root of its own: it is part of the same question as
 * "who is signed in", and signing out should drop it with everything else.
 */
export const extensionIdKeys = {
  trusted: () => [...sessionKeys.all, 'extension-ids'] as const,
};

export function fetchTrustedExtensionIds(): Promise<string[]> {
  return apiFetch<TrustedExtensionIdsResponse>('/auth/extension-ids').then(
    (response) => response.ids,
  );
}
